import React from "react";
import App from "./App";
// React 18: createRoot replaces the legacy ReactDOM.render entry point.
// ReactDOM.createPortal call sites (forms-library-list, response-settings/*)
// still work via the regular `react-dom` import and don't need changes.
import { createRoot } from "react-dom/client";

import initStore from "./redux/store";
import { Provider } from "react-redux";
import { bindActionCreators } from "redux";
import reportWebVitals from "./reportWebVitals";
import LoadingBar from "react-redux-loading-bar";
import setupAxiosInterceptors from "./config/axios-interceptor";
import "./config/dayjs-setup";
import { clearAuthentication } from "./redux/reducers/authentication/authentication";
import { SidebarProvider } from "./pages/private/analytics/useSidebarProvider";
import "../src/index.css";

// react-filerobot-image-editor ships 3 pre-compiled lib files (e.g.
// HistoryButtons.js) that reference a bare global `React` without importing it.
// CRA/babel used to provide React in scope; the Vite prod build does NOT, so the
// image editor threw "ReferenceError: React is not defined" and crashed the page
// the moment it opened (the editor topbar renders HistoryButtons). Exposing React
// on the global object resolves those bare references for every browser. This
// runs at app startup, long before the lazy form-view chunk (the editor) loads.
// Reproduced + verified fixed against the production Vite build via Playwright.
if (typeof window !== "undefined") {
  window.React = React;
}

const store = initStore();
const actions = bindActionCreators({ clearAuthentication }, store.dispatch);

setupAxiosInterceptors(() =>
  actions.clearAuthentication("login.error.unauthorized")
);

let deviceId = localStorage.getItem("deviceId");

if (!deviceId) {
  deviceId =
    (
      Date.now().toString(36) +
      Math.random().toString(36).substr(2, 5)
    ).toUpperCase() +
    Math.random().toString(36).substr(2, 9);

  localStorage.setItem("deviceId", deviceId);
}

// use deviceId safely here


const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SidebarProvider>
        <LoadingBar
          className="loading-bar"
          style={{
            height: "3px",
            backgroundColor: "#2D9CDB",
            position: "absolute",
            top: "0px",
            zIndex: "1031",
          }}
        />
        <App />
      </SidebarProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
